import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) =>
  state.configuratorData || initialState;

export const selectItemsData = createSelector(
  [selectSlice],
  state => state.data.items,
);

export const selectFilterAttributesData = createSelector(
  [selectSlice],
  state => state.data.filterAttributes,
);

export const selectTotalItemsData = createSelector(
  [selectSlice],
  state => state.data.total,
);

export const selectItemsIsLoading = createSelector(
  [selectSlice],
  state => state.isLoading,
);

export const selectDisplaySafetyFactor = createSelector(
  [selectSlice],
  state => state.displaySafetyFactor,
);

export const selectIsConfiguratorDataComplete = createSelector(
  [selectSlice],
  state => state.isApiComplete,
);
export const selectMountingApply = createSelector(
  [selectSlice],
  state => state.mountingApply,
);
